<template>
	<div class="container">
		<loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="true"
            color="#007bff"
      		background-color="#ffffff"
        >
        </loading>
		<div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Generált számla lista
    		</div>
		</div>
		<div class="table-responsive">
			<table class="table table-striped">
				<thead>
					<th>Dátum</th>
					<th>Felhasználó</th>
					<th>Letöltés</th>
					<th>Újra letöltés a<br>billingotól hiba esetén</th>
				</thead>
				<tbody>
					<tr
						v-for="(v,k) in list"
						:key="k"
					>
						<td>{{ v.date | toDateHourMin }}</td>
						<td>{{ v.user }}</td>
						<td>
							<i
								class="fas fa-cloud-download-alt pointer"
								@click.prevent="download(JSON.parse(v.invoices).list)"
							>
							</i>
						</td>
						<td>
							<i
								class="fas fa-cloud-download-alt pointer"
								@click.prevent="redownload(v)"
							>
							</i>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<paginate
			class="pb-3"
			v-if="sum"
			:total="sum"
		>
		</paginate>
	</div>
</template>
<script type="text/javascript">
import moment from 'moment'
export default {
	data() {
		return {
			list: [],
			sum: null
		}
	},

	created() {
		this.load()
	},

	methods: {
		load() {
			this.$Progress.start()
			let params = Object.assign({}, this.$route.query)
			this.req.get('/orders/billing/list', {params})
				.then(res=>{
					this.list = res.data.list
					this.sum = res.data.sum
					this.$Progress.finish()
				})
				.catch(err=>{
					toastr.error(err)
					this.$Progress.fail()
				})
		},

		download(list) {
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/billing/list/download', {
				list: list
			}, { responseType: 'blob' } )
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
				   	const link = document.createElement('a')
				   	link.href = url
				   	link.setAttribute('download', 'számlák.pdf')
				   	document.body.appendChild(link)
				   	link.click()
					this.$Progress.finish()
					this.isLoading = false
				})
				.catch(err => {
					toastr.error(err.response.data.text || 'hiba a letöltésben')
			      	this.$Progress.fail()
			      	this.isLoading = false
				})
		},

		redownload(val) {
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/invoicelist/' + val.id)
				.then(res => {
					toastr.success('Újraletöltés sikeres')
					this.$Progress.finish()
					this.isLoading = false
					//let l = JSON.parse(val.invoices).list
					//this.download(l)
				})
				.catch(err => {
					toastr.error(err.response.data.text || 'hiba a letöltésben')
			      	this.$Progress.fail()
			      	this.isLoading = false
				})
		}
	},

	watch: {
		'$route'(to,from) {
			this.load()
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/billings.vue